/**
 * Client-side YouTube video category labels for the Videos page.
 */
export function getVideoCategory(title, description = '') {
  if (title.includes('| Part ')) {
    return 'Gameplay';
  }
  if (
    /tutorial|how to|guide|setup|Streamer\.bot|walkthrough|plugin|tool|Built|Customizer|ULTIMATE|DEATH.*COUNTER|COUNTER.*DEATH|zoom|track|mouse|follow/i.test(
      title,
    )
  ) {
    return 'Tutorials';
  }
  if (
    /step-by-step|In this.*tutorial|zoom.*mouse|track.*mouse|follow.*mouse/i.test(
      description,
    )
  ) {
    return 'Tutorials';
  }
  if (
    /gameplay|playthrough|let's play|match|session|\| PC \||\bPC\b/i.test(title)
  ) {
    return 'Gameplay';
  }
  return null;
}

export function sortVideosByDate(videos) {
  return [...videos].sort(
    (a, b) =>
      new Date(b.snippet.publishedAt).getTime() -
      new Date(a.snippet.publishedAt).getTime(),
  );
}
